// src/auth/api.js
import axios from "axios";

const fromConfig = (window.__APP_CONFIG__ && window.__APP_CONFIG__.API_BASE) || "";
const fromVite   = (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API_BASE) || "";
const fromCRA    = process.env.REACT_APP_API_BASE || "";
const trimSlash = (s) => (s || "").replace(/\/+$/, "");
const API_BASE = trimSlash(fromConfig || fromVite || fromCRA) || "http://localhost:3001";

console.log("📡 API_BASE =", API_BASE);

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: false,
  timeout: 20000,
});

// Adjunta token si existe
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Manejo 401: defensivo
let handling401 = false;

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const cfg = err?.config || {};
    const url = String(cfg.url || "");
    const method = (cfg.method || "GET").toUpperCase();
    const hadAuth = !!(cfg.headers && (cfg.headers.Authorization || cfg.headers.authorization));
    const isAuthEndpoint = /\/auth\/(login|refresh)/i.test(url);

    // Si es error de red (CORS, servidor caído), NO desloguees.
    if (err?.code === "ERR_NETWORK" || typeof status === "undefined") {
      console.warn("🌐 Network error (no logout):", method, url, err?.message);
      return Promise.reject(err);
    }

    // Solo actuamos en 401 válidos y con header Authorization
    if (status === 401 && hadAuth && !isAuthEndpoint) {
      console.warn("🔐 401 con Authorization en:", method, url);
      if (!handling401) {
        handling401 = true;
        // Limpieza suave
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        // Redirige dentro de la SPA si no estás ya en /login
        if (window.location.pathname !== "/login") {
          // Preferible dejar que ProtectedRoute te lleve.
          // Forzamos navegación SPA:
          window.history.pushState({}, "", "/login");
          window.dispatchEvent(new PopStateEvent("popstate"));
        }
        // pequeña ventana para evitar storms de 401
        setTimeout(() => { handling401 = false; }, 1500);
      }
    }

    return Promise.reject(err);
  }
);
export { API_BASE };
export default api;
